import defaultIcon from './assets/system3-logo.svg';

export const SITE_NAME = "TODO";
export const PROGRESSIVE_APP = false	;
export const FORCE_RENDER = true	;
export const CANONICAL_URL =  process.env.NODE_ENV ==='production'? "http://localhost:300" : "TODO";;
export const LOG_OUT_ROUTE = "/logout";
export const API_REFRESH_ROUTE = process.env.NODE_ENV ==='production'? "TODO" : "TODO";
export const API_DOMAIN = process.env.NODE_ENV ==='production'? "TODO" : "TODO";
export const DEFAULT_ICON = defaultIcon;